import EntryPoint from "../../../containers/Profile/MyOffers/MyOffersContainer";
import { RouteObject } from "../../../interfaces/navigation";

export const myOffersRoutes: RouteObject[] = [
    {
        title: "Mis Ofertas",
        path: "mis_ofertas",
        component: <EntryPoint/>
    }
];